import './style.scss';
import { TranslationService } from '../../../services/translation.service';
import { TransportMode } from '../../../models/transport-mode.enum';
import type { ILine } from '../../../models/line.model';

function LineIcon({ line, className = '' }: { line: ILine; className?: string }) {
  function getDisplayName() {
    if (line.transportMode === TransportMode.train) {
      return `${line.name} ${line.designation ?? ''}`;
    }
    // NV-5212 - Buss on demand should be removed when trial period is over
    if (line.transportMode === TransportMode.bussondemand) {
      return line.name;
    }
    return line.shortName;
  }

  return (
    <div className={`line-icon-component rounded text-center ${className}`} style={{ background: line.backgroundColor, color: line.foregroundColor, borderColor: line.borderColor }}>
      <span className="fw-bold">
        <span className="visually-hidden">{TranslationService.get('common.line')} </span>
        {getDisplayName()}
      </span>
    </div>
  );
}

export default LineIcon;
